







import { Component, Vue } from "vue-property-decorator";
import { reportIndexPvUvAndTimeCost } from "@tencent/ppd-base-libs";

@Component({})
export default class App extends Vue {
  created() {
    reportIndexPvUvAndTimeCost();
    return;
  }
}
